import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchList',
})
export class SearchListPipe implements PipeTransform {
  transform(
    list: any[],
    filterExpr?: (
      item: any,
      filterValue: any,
      index: number,
      arr: any[]
    ) => boolean,
    filterValue?: any
  ) {
    if (filterExpr) {
      list = list?.filter((item, index, arr) =>
        filterExpr(item, filterValue, index, arr)
      );
    }

    return list;
  }
}
